import React from "react"
import styled from "styled-components"
import { useStaticQuery, grapqhl } from "gatsby"
import Img from "gatsby-image"
import { remCalc, pageMargins } from "../../../styles/utils.js"
const StyledJobs = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;

  & .jobs_image-stat {
    padding-top: 5rem;
    padding-bottom: 5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${pageMargins};
    /* &:not(.no-image) {
    } */

    & h4 {
      font-size: 2.5rem;
      line-height: ${remCalc(50)};
      width: 40%;
    }
    & h3 {
      font-size: ${remCalc(56)};
      line-height: ${remCalc(68)};
      width: 30%;
    }
    p {
      font-size: ${remCalc(30)};
      line-height: ${remCalc(40)};
      width: 50%;
    }
    .jobs_image-pattern {
      width: 30vw;
      height: 34vw;
      background: black;
    }
  }
`

const Jobs = () => {
  const data = useStaticQuery(graphql`
    query {
      pattern: file(relativePath: { eq: "jobs-stat-pattern.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <StyledJobs className="full-width" data-scroll>
      <div className="jobs_image-stat">
        <div className="jobs_image-pattern" data-scroll data-scroll-speed="1">
          <Img fluid={data.pattern.childImageSharp.fluid} />
        </div>

        <h4>
          Landsec's ten-year contribution to the economy through property
          development.
        </h4>
      </div>
      <div className="jobs_image-stat">
        <h4>
          Number of jobs created in construction through Landsec's development
          activities over the last decade.
        </h4>
        <div className="jobs_image-pattern" data-scroll data-scroll-speed="1">
          <Img fluid={data.pattern.childImageSharp.fluid} />
        </div>
      </div>
      <div className="jobs_image-stat no-image">
        <h3>We don’t just build and rent out buildings</h3>
        <p className="jobs_image-para">
          We create destinations for business of all sizes from start ups to
          international conglomerates – to inspire workforces, increase
          productivity and drive optimal performance.
        </p>
      </div>
    </StyledJobs>
  )
}

export default Jobs
